import router from "./router";
import store from "./store";
import { getToken, removeToken } from "@/utils/auth"; // 验权

const whiteList = ["/"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (getToken()) {
    // if (null != store.getters.navs && store.getters.navs.length > 0) {
    
    // } else {
    //   removeToken();
    //   next("/");
    // }
    if (to.path === '/') {
      next("/index");
    } else if (to.path === '/index') {
      store.dispatch('GetInfo').then(() => {
        next();
      })
    } else {
      if (store.getters.permissions.length === 0) {
        store.dispatch('GetInfo').then(() => {
          next();
        })
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/");
    }
  }
});
